
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class UserService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    find(query?:any) {
        return this.get('/find-user',query);
    }

    list(query?: any) {
        return this.get('/users',query);
    }

    create(body: any) {
        return this.post('/create-user',body);
    }

    update(id, body) {
        return this.put('/update-user/'+id, body);
    }

    all(query?: any) {
        return this.get('/all-user', query);
    }
    usersAllRole(query?: any) {
        return this.get('/users-all-role',query);
    }

    resetPass(user_id, data) {
        return this.post('/reset-password/'+user_id, data);
    }

    merge(data) {
        return this.post('/user/merge/', data);
    }
    updateCurentTime(data) {
      localStorage.removeItem('User');
      localStorage.setItem('User',JSON.stringify(data) );
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/User.service.ts